import React from "react";
import ImageSlider from "../../../components/common/SlideShowImage/ImageSlider";
import images from "../../../images";
import { useTranslation } from "react-i18next";
import { cn } from "../../../Utils/helper";

const HeaderQuestPratice = ({
  thumbnails,
  consumerStatus,
  businessAvatar,
  fileName,
  menuHandleClick,
  menuIcon,
  onMenuClick,
  isDropDownOpen,
  onDropDownPauseClick,
  onDropDownEndClick,
  handleEdit,
  btnEdit,
  classNameBtnEdit,
  subTitle,
  onDropReportClick,
  quotaType,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center w-full bg-[#ECEEFF]">
      <div className="w-full relative ">
        <ImageSlider
          // images={thumbnails}
          imageHeight={"h-[75px]"}
          // applyImageOverlay={true}
          className="rounded-none"
        />
        {menuIcon ? (
          <>
            {isDropDownOpen && (
              <div
                className="fixed inset-0 bg-white opacity-0 z-40"
                onClick={() =>
                  typeof onMenuClick === "function" && onMenuClick()
                }
              />
            )}
            <div
              onClick={() => typeof onMenuClick === "function" && onMenuClick()}
              className="absolute top-[39px] right-6 cursor-pointer z-50"
            >
              <img
                loading="lazy"
                src={menuIcon}
                alt="Avatar"
                className="object-contain self-stretch my-auto w-6 h-6 rounded-md aspect-square"
              />
              {isDropDownOpen && (
                <div
                  className="flex flex-col  absolute right-[2px] top-[36px] z-50 px-3 py-6 justify-center items-start w-full min-w-[120px] bg-white rounded-[10px]   border-[#EEEAE8] border-solid border-[1px]"
                  style={{
                    boxShadow: "0 3px 6px 0 rgba(72, 72, 72, 0.5)",
                  }}
                >
                  {quotaType === "SLOT" && (
                    <div
                      onClick={() =>
                        typeof onDropDownPauseClick === "function" &&
                        onDropDownPauseClick()
                      }
                      className="w-full cursor-pointer  rounded-t-[10px] border-b border-[#EEEAE8]"
                    >
                      <div className="flex flex-row justify-start items-center pb-[18px] gap-1.5 ">
                        <img
                          src={images.CarbonPauseOutlineBlue}
                          alt=""
                          className="w-6 h-6"
                        />
                        <span className="text-lg font-medium text-[#253FF6]">
                          {t("quest.detailMultipleChoice.pauseQuest")}
                        </span>
                      </div>
                    </div>
                  )}
                  <div
                    onClick={() =>
                      typeof onDropDownEndClick === "function" &&
                      onDropDownEndClick()
                    }
                    className="w-full cursor-pointer rounded-t-[10px] border-b border-[#EEEAE8]"
                  >
                    <div
                      className={cn(
                        "flex flex-row justify-start items-center py-[18px] gap-1.5 ",
                        quotaType !== "SLOT" && "pt-0"
                      )}
                    >
                      <img
                        src={images.CarbonCloseOutlineBlue}
                        alt=""
                        className="w-6 h-6"
                      />
                      <span className="text-lg font-medium text-[#253FF6]">
                        {t("quest.detailMultipleChoice.quitQuest")}
                      </span>
                    </div>
                  </div>
                  <div
                    onClick={() =>
                      typeof onDropReportClick === "function" &&
                      onDropReportClick()
                    }
                    className="w-full cursor-pointer  rounded-t-[10px]"
                  >
                    <div className="flex flex-row justify-start items-center pt-[18px] gap-1.5 ">
                      <img
                        src={images.CircleWarningIconBlue}
                        alt=""
                        className="w-6 h-6"
                      />
                      <span className="text-lg font-medium text-[#253FF6]">
                        {t("base.report")}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : btnEdit ? (
          <button className={classNameBtnEdit} onClick={handleEdit}>
            {btnEdit}
          </button>
        ) : subTitle ? (
          <div
            onClick={() =>
              typeof onDropDownEndClick === "function" && onDropDownEndClick()
            }
            className="flex bg-white cursor-pointer px-1 overflow-hidden gap-[6px] justify-center items-center self-stretch my-auto rounded-[5px] h-[32px] w-[80px]"
          >
            <span className="text-xs text-[#EF4056]">{subTitle}</span>
          </div>
        ) : (
          <div className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px]" />
        )}
        <div
          className={`flex absolute ${
            consumerStatus === "NOT_STARTED" ? "top-[30px]" : "top-[30px]"
          } left-[30px] flex-col self-start text-xs font-bold text-center text-black rounded-none h-[70px] w-[70px] z-20`}
        >
          <figure className="flex shrink-0 self-stretch my-auto" />
          {businessAvatar ? (
            <img
              src={`${process.env.REACT_APP_URL_IMAGE}/${businessAvatar}`}
              className="w-[70px] h-[70px] rounded-[6px] border border-[#E9E6E4] bg-gray-100 object-cover"
              alt={fileName || ""}
            />
          ) : (
            <img
              src={images.RetailStoreIcon}
              className="w-[70px] h-[70px] rounded-[6px] bg-gray-100 object-scale-down"
              alt={fileName || ""}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderQuestPratice;
